export enum PatientImmunizationsConstants {
  SET_IMMUNIZATION_NUMBER = 'patientImmunization/SET_IMMUNIZATION_NUMBER',
  SET_YEAR = 'patientImmunizations/SET_YEAR',
  SET_OTHERNAME = 'patientImmunizations/SET_OTHERNAME',
  SET_UPTODATE = 'patientImmunizations/SET_UPTODATE',
  SET_PATIENT_IMMUNIZATION_TYPE = 'patientImmunizations/SET_IMMUNIZATION',
  SAVE_IMMUNIZATION = 'patientImmunizations/SAVE_IMMUNIZATION',
  SET_IMMUNIZATIONS = 'patientImmunizations/SET_IMMUNIZATIONS',
  ADD_PATIENT_IMMUNIZATION_CARD = 'patientImmunizations/ADD_PATIENT_IMMUNIZATION_CARD',
  SET_PATIENT_IMMUNIZATIONS = 'patientImmunizations/SET_PATIENT_IMMUNIZATIONS',
  SET_PATIENT_IMMUNIZATIONS_STATUS = 'patientImmunizations/SET_PATIENT_IMMUNIZATIONS_STATUS',
  SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON = 'patientImmunization/SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON',
  REMOVE_PATIENT_IMMUNIZATION = 'patientImmunization/REMOVE_PATIENT_IMMUNIZATION',
  RESET_PATIENT_IMMUNIZATIONS = 'patientImmunizations/RESET_PATIENT_IMMUNIZATIONS',
}
